import { useEffect, useState } from "react";
import { Menu, MessageSquarePlus, SquareArrowLeft, Download } from 'lucide-react';
import { removeUser } from '@/user/userSlice';
import ChatList from './ChatList';
import { useAppDispatch, useAppSelector } from '@/store';
import { closeSidebar, resetChats, selectSidebarOpen } from './chatSlice';
import { resetMessages, startNewChat } from '@/messages/messageSlice';

export default function Sidebar() {
  const dispatch = useAppDispatch();
  const open = useAppSelector(selectSidebarOpen);
  const displayName = useAppSelector((s: any) => s.user.displayName)
  const username = useAppSelector((s: any) => s.user.username); // ?? localStorage.getItem('displayName'));

  const [promptEvent, setPromptEvent] = useState<any>(null);
  const [isStandalone, setIsStandalone] = useState(false);
  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true;
    setIsStandalone(standalone);
    const handler = (e: any) => { e.preventDefault(); setPromptEvent(e); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/40 z-30 transition-opacity md:hidden
          ${open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
        `}
        onClick={() => dispatch(closeSidebar())}
      />
      <aside
        className={`z-40 h-[100dvh] bg-white shadow-xl flex flex-col w-[320px] transition-transform duration-300 fixed left-0 top-0 md:static overflow-hidden
          ${open ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        <div className="h-16 flex items-center gap-2 p-4 bg-blue-700 border-b border-blue-800 shadow-md shrink-0 items-center">
          <Menu size={24} className="text-white hover:text-blue-400" onClick={() => dispatch(closeSidebar())} />
          <span className="font-semibold text-white">Hi, {displayName || username}!</span>
          {!isStandalone && promptEvent && (
            <div className="ml-auto flex">
              <button
                onClick={() => promptEvent.prompt()}
                className="p-2 rounded-lg text-white hover:text-blue-400 transition"
                title="Install App"
              ><Download size={18} />
              </button>
            </div>
          )}
        </div>

        <div className="flex-1 overflow-y-auto">
          <ChatList />
        </div>

        <div className="p-3 border-t border-slate-200 flex items-center gap-2">
          <button
            onClick={() => {
              dispatch(removeUser());
              dispatch(resetChats());
              dispatch(resetMessages());
              dispatch(closeSidebar());
            }}
            className="h-10 w-10 flex items-center justify-center rounded-xl bg-slate-300 hover:bg-red-400 text-white"
            title="Logout"
          >
            <SquareArrowLeft size={18} />
          </button>
          <button
            onClick={() => {
              dispatch(startNewChat());
              dispatch(closeSidebar());
            }}
            className="flex-1 flex items-center justify-center gap-2 p-3 rounded-xl bg-blue-600 hover:bg-blue-800 text-white text-sm"
          >
            <MessageSquarePlus size={16} />
            New Chat
          </button>
        </div>
      </aside>
    </>
  );
}
